import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

import { AuthService } from "../services/auth/auth.service";
import { jwtDecode } from "jwt-decode";
import { environment } from "../../../environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Verificar se a requisição é para a API do WhatsApp
    const isWhatsAppApi = request.url.includes(environment.whatsappApiUrl);
    
    // Se for para a API do WhatsApp, não adicionar o JWT token
    if (isWhatsAppApi) {
      return next.handle(request);
    }
    
    const currentUser = this.authService.currentUserValue;

    if (currentUser && currentUser.token) {
      const decodedToken: any = jwtDecode(currentUser.token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp < currentTime) {
        // Token expirado, desloga o usuário
        this.authService.logout();
        return next.handle(request); // Retorna a requisição sem o token
      }

      // Se o token for válido, adiciona ao cabeçalho
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      });

      // Armazena permissões no localStorage, se necessário
      if (decodedToken.permissions) {
        localStorage.setItem("userPermissions", JSON.stringify(decodedToken.permissions));
      }
    }

    return next.handle(request);
  }
}
